<div class="app-download-container">
    <h5 class="app-download__title_web">{{'scan_qr_or_go_to_store' | translate}}</h5>
    <h6 class="app-download__title_ph">{{'download_mobile_app' | translate}} </h6>
    <hr class="m-0">
    <div class="app-download-section">
        <img class="mobile-phone-app" src="../../../../assets/images/profile-phone.png" alt="" height="265">
        <div class="qr-app-link">
            <div class="app-download-buttons">
                <img id="android-download-btn" src="../../../../assets/images/android-app-download-button.png" alt="">
                <img id="iphone-download-btn" src="../../../../assets/images/iphone-app-download-button.png" alt="">
            </div>
            <img class="qr-code-section" src="../../../../assets/images/qr-code.png" alt="">
        </div>
    </div>
    <hr class="m-0">
    <div>
        <h6>{{'seamless_expense_management_software' | translate}}</h6>
     <img src="../../../../assets/images/rating.svg" alt="">
    </div>
    <div class="app-download-mobile">
        <img id="android-download-btn" src="../../../../assets/images/android-app-download-button.png" alt="">
        <img id="iphone-download-btn" src="../../../../assets/images/iphone-app-download-button.png" alt="">
    </div>
    <ds-button
        [buttonInput]="continueConfig"
        (btnClick)="goToDashboard()">
    </ds-button> 
</div>